(function(){

  const builder = document.querySelector("[data-echo-bundle]");
  if(!builder) return;

  const productForm = document.querySelector("[data-product-form]");
  if(!productForm) return;

  const slotsContainer = builder.querySelector(".vpb__slots");
  const productCards = builder.querySelectorAll(".vpb__product-card");
  const addToCartBtn = productForm.querySelector("[type='submit']");
  const messageBox = builder.querySelector(".vpb__message");

  /* -----------------------------------
     Active Variant Setup
  -----------------------------------*/
  const activeVariantsRaw = builder.dataset.activeVariants || "";

  const activeVariants = activeVariantsRaw
    .split(",")
    .map(v => v.trim().toLowerCase())
    .filter(v => v !== "");

  let selected = [];
  let packSize = 0;

  /* -----------------------------------
     Helpers
  -----------------------------------*/

  function getPackSize(title){
    const match = title.match(/\d+/);
    return match ? parseInt(match[0]) : null;
  }

  function isVariantActive(title){
    if(!title) return false;
    return activeVariants.includes(title.trim().toLowerCase());
  }

  function removeOldProperties(){
    productForm.querySelectorAll(".bundle-prop")
      .forEach(el => el.remove());
  }

  function showMessage(text){
    if(!messageBox) return;
    messageBox.textContent = text;
    messageBox.style.display = "block";

    setTimeout(()=>{
      messageBox.style.display = "none";
    },3000);
  }

  function updateDynamicButtons(){
    const dynamicButtons = productForm.querySelector('.shopify-payment-button')
      || document.querySelector('.shopify-payment-button');
    if(!dynamicButtons) return;
    const incomplete = packSize > 0 && selected.length < packSize;
    dynamicButtons.style.opacity = incomplete ? '0.4' : '';
    dynamicButtons.style.pointerEvents = incomplete ? 'none' : '';
  }

  /* -----------------------------------
     Render Slots + Properties
  -----------------------------------*/

  function render(){
    if(!slotsContainer) return;
    slotsContainer.innerHTML = "";
    removeOldProperties();
    for(let i=0;i<packSize;i++){
      const slot = document.createElement("div");
      slot.className = "vpb__slot";

      if(selected[i]){
        slot.innerHTML = `
          <img src="${selected[i].image}" width="100%" />
          <span class="vpb_product-title hidden">${selected[i].title}</span>
          <button type="button" class="vpb__remove">✕</button>
        `;

        slot.querySelector(".vpb__remove")
          .addEventListener("click", ()=> {
            selected.splice(i,1);
            render();
          });

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `properties[Flavor ${i+1}]`;
        input.value = selected[i].title;
        input.classList.add("bundle-prop");

        productForm.appendChild(input);
      } else {
        slot.innerHTML = `<span class="vpb_empty rte">Empty</span>`;
      }
      slotsContainer.appendChild(slot);
    }
    updateDynamicButtons();
  }

  /* -----------------------------------
     Handle Variant Change
  -----------------------------------*/

  function handleVariant(variantTitle){
    if(!isVariantActive(variantTitle)){
      builder.classList.add("hidden");
      packSize = 0;
      selected = [];
      render();
      updateDynamicButtons();
      return;
    }

    const size = getPackSize(variantTitle);
    if(size){
      packSize = size;
      selected = [];
      builder.classList.remove("hidden");
      render();
    }
  }

  /* -----------------------------------
     Add Product Click
  -----------------------------------*/

  productCards.forEach(card => {
    card.addEventListener("click", function(){
      if(selected.length >= packSize){
        showMessage("You have already selected the maximum products.");
        return;
      }

      selected.push({
        title: card.dataset.title,
        image: card.dataset.image,
        variantId: card.dataset.variant
      });

      render();
    });
  });

  /* -----------------------------------
     Add To Cart Validation
  -----------------------------------*/

  addToCartBtn.addEventListener("click", function(e){
    if(packSize > 0 && selected.length !== packSize){
      e.preventDefault();
      const remaining = packSize - selected.length;
      showMessage(
        `Please select ${remaining} more product${remaining > 1 ? "s" : ""}.`
      );
      return;
    }

  });

  /* -----------------------------------
     Shapes Variant Change Event
  -----------------------------------*/

  document.body.addEventListener("shapes:product:variantchange", function(e){

    const variant = e?.detail?.variant;
    if(!variant) return;

    handleVariant(variant.title);

  });

  /* -----------------------------------
     Clear After AJAX Cart Add
  -----------------------------------*/

//   document.body.addEventListener("shapes:cart:afteradditem", function(){

//     selected = [];
//     render();

//   });

  /* -----------------------------------
     On Page Load
  -----------------------------------*/

  document.addEventListener("DOMContentLoaded", function(){
    const variantInput = productForm.querySelector("[name='id']");
    if(!variantInput) return;
    let title = "";

    if(variantInput.options){
      title = variantInput.options[variantInput.selectedIndex]?.textContent;
    }

    if(title){
      handleVariant(title);
    }
  });

})();